import { graphql } from "@opensea/graphql"
import { CancelOrderTableRow_orderFragment } from "../CancelOrderTableRow/CancelOrderTableRow.fragment"
import { CancelOrderTableHeaderFragment } from "./CancelOrderTableHeader.fragment"

export const CancelOrderTableFragment = graphql(
  `
    fragment CancelOrderTable on Order {
      id
      ...CancelOrderTableRow_order
      ...CancelOrderTableHeader
    }
  `,
  [CancelOrderTableRow_orderFragment, CancelOrderTableHeaderFragment],
)
